.page {
  min-block-size: 100dvh;
  display: grid;
  place-items: center;
  padding: var(--space-6) var(--space-4);
  background:
    radial-gradient(1200px 500px at 10% -10%, var(--color-accent-subtle), transparent 60%),
    var(--color-canvas);
}

.card {
  inline-size: min(480px, 100%);
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  padding: var(--space-8);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-l);
  background: var(--color-surface);
  box-shadow: var(--shadow-m);
  outline: none;
}

.cardWide {
  inline-size: min(720px, 100%);
}

.brand {
  display: flex;
  align-items: center;
  gap: var(--space-3);
}

.brand > span:last-child {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.mark {
  display: grid;
  place-items: center;
  inline-size: 40px;
  block-size: 40px;
  border-radius: var(--radius-s);
  background: linear-gradient(140deg, var(--petrol), var(--petrol-900));
  color: #eafff9;
  font-family: var(--font-mono);
  direction: ltr;
}

.brandName {
  font-weight: 600;
}

.appTitle {
  font-family: var(--font-mono);
  font-size: var(--text-xs);
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--color-text-eyebrow);
}

.title {
  font-family: var(--font-display);
  font-weight: 500;
  font-size: var(--text-2xl);
}

.lead {
  color: var(--color-text-muted);
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
}

.steps {
  display: grid;
  gap: var(--space-4);
  margin: 0;
  padding: 0;
  list-style: none;
  counter-reset: step;
}

.steps > li {
  display: grid;
  grid-template-columns: 32px 1fr;
  gap: var(--space-3);
  align-items: start;
  counter-increment: step;
}

.steps > li::before {
  content: counter(step);
  display: grid;
  place-items: center;
  inline-size: 28px;
  block-size: 28px;
  border-radius: 50%;
  background: var(--color-accent-subtle);
  color: var(--color-on-accent-subtle);
  font-family: var(--font-mono);
  font-size: var(--text-sm);
}

.qrRow {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-4);
  align-items: center;
}

.qr {
  inline-size: 168px;
  block-size: 168px;
  padding: var(--space-2);
  border-radius: var(--radius-m);
  background: #fff;
  border: 1px solid var(--color-border);
}

.secret {
  font-family: var(--font-mono);
  font-size: var(--text-sm);
  letter-spacing: 0.08em;
  overflow-wrap: anywhere;
  direction: ltr;
  unicode-bidi: isolate;
}

.codes {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--space-2) var(--space-6);
  margin: 0;
  padding: var(--space-4);
  border: 1px dashed var(--color-border-control);
  border-radius: var(--radius-m);
  background: var(--color-surface-sunken);
  list-style: none;
  font-family: var(--font-mono);
  font-size: var(--text-lg);
  letter-spacing: 0.08em;
  direction: ltr;
}
